import {Component, Input, ViewContainerRef} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {DistributionAccount} from '../../../../distribution-account/distribution-account.model';
import {SegmentRemoveShareDialogComponent} from '../../../share/remove-share-dialog.component';

@Component({
  selector: 'app-segment-info-target',
  template: `
    <div class="target-list-item">
      <div class="line">
        <span class="name" data-name="account-data">{{account.description || "no description"}}</span>
      </div>
      <div>
        <span class="foreignid">ID: <span data-name="foreign_id">{{account.foreignIdForCurrentSegment}}</span></span>
      </div>
      <button mat-icon-button
              class="button-account-menu"
              id="button-acount-remove-{{account.id}}"
              name="button-acount-remove-{{account.id}}"
              data-cy="button-target-account-delete"
              value="{{account.id}}" (click)="showDialog()">
        <mat-icon>delete</mat-icon>
      </button>
      <!-- include detailed account component-->
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['account.component.scss']
})
export class SegmentInfoAccountComponent {

  @Input() account!: DistributionAccount;

  dialogRef!: MatDialogRef<SegmentRemoveShareDialogComponent>;

  constructor(private viewContainerRef: ViewContainerRef, private dialog: MatDialog) {
  }

  showDialog() {
    const config = new MatDialogConfig();
    this.dialogRef = this.dialog.open(SegmentRemoveShareDialogComponent, config);
    this.dialogRef.componentInstance.account = this.account;
  }
}
